<script setup lang="ts">
import { computed, useSlots, type VNode, type VNodeArrayChildren } from 'vue';
import { SelectValue } from 'radix-vue';

const props = defineProps({
  placeholder: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
});

const slots = useSlots();

const extractText = (
  children: VNodeArrayChildren | VNode[] | string | null | undefined
): string => {
  if (!children) return '';
  if (typeof children === 'string') return children;
  if (!Array.isArray(children)) return '';

  return children
    .map((child) => {
      if (typeof child === 'string') return child;
      if (typeof child === 'number') return String(child);
      if (!child || typeof child !== 'object') return '';

      const vnode = child as VNode;
      if (typeof vnode.children === 'string') return vnode.children;
      if (Array.isArray(vnode.children)) return extractText(vnode.children);

      return '';
    })
    .join('')
    .replace(/\s+/g, ' ')
    .trim();
};

const fallbackPlaceholder = computed(() => props.placeholder || extractText(slots.default?.()));
</script>

<template>
  <SelectValue v-bind="props" :placeholder="fallbackPlaceholder" />
</template>
